'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _logo522x = require('./images/logo52@2x.png');

var _logo522x2 = _interopRequireDefault(_logo522x);

var _Locale = require('./lang/Locale');

var _Locale2 = _interopRequireDefault(_Locale);

var _base = require('base-64');

var _base2 = _interopRequireDefault(_base);

require('./PCBasicIntro.css');

require('regenerator-runtime/runtime');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

require('url-search-params-polyfill');

var WebBaseIntro = function (_React$Component) {
    _inherits(WebBaseIntro, _React$Component);

    function WebBaseIntro() {
        var _ref;

        var _temp, _this2, _ret;

        _classCallCheck(this, WebBaseIntro);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = WebBaseIntro.__proto__ || Object.getPrototypeOf(WebBaseIntro)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
            beianText: '京ICP备18016017号-7',
            companyEnName: 'Beijing Xiaowei Cloud Inc.',
            downloadHost: 'https://download.xdiarys.com',
            downloadFileName: '/windows/xdiarys-setup-v3.exe',
            macOSUrl: '',
            iOSUrl: '',
            helpRecent: [],
            showBeianText: false,
            showHelp: false,

            contantUsQQWindows: '',
            contantUsQQMacos: '',
            contantUsEmail: 'service@xiaoweiyunfu.com',

            threeMonthPayAmount: 28,
            oneYearPayAmount: 68,
            threeYearPayAmount: 148,

            paymentMethod: '',
            radioChecked: 3,
            showQR: false,

            wechatpayimage: '',
            wechatPayShow: false,
            wechatPayAmount: 0,

            tn: ''
        }, _temp), _possibleConstructorReturn(_this2, _ret);
    }

    _createClass(WebBaseIntro, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this3 = this;

            var search = new URLSearchParams(location.search);

            var inweb = search.get("inweb");
            if (inweb != null && inweb == 1) {
                this.setState({ payInWeb: true });
            }

            // 看有没有token，种cookie
            var token = search.get("token");

            if (token && token.length > 0) {
                token = decodeURIComponent(token, true);
                var cookie = _base2["default"].decode(token);
                var arrCookie = cookie.split(";");

                if (arrCookie.length > 0) {
                    this.clearAllCookie();
                }

                for (var i = 0; i < arrCookie.length; i++) {
                    var arr = arrCookie[i].split("=");
                    var key = arr[0];
                    var value = arr[1];

                    if (key && value) {
                        this.setCookie(key, value);
                    }
                }
            }

            // 语言设置
            var paramLang = search.get("lang");
            if (null == paramLang || paramLang.length === 0) {
                //paramLang = "chs";
            }

            var oldUserName = this.getCookieValue('dcufnm');
            var newUserName = oldUserName;
            do {
                oldUserName = newUserName;
                newUserName = decodeURIComponent(oldUserName, true);
            } while (newUserName != oldUserName);

            this.setState({ pay_user: newUserName });

            _Locale2["default"].GetInstance().InitLang(paramLang, navigator.language || navigator.userLanguage);

            var paramTN = search.get("tn");
            if (null != paramTN && paramTN.length > 0) {
                this.setState({ tn: paramTN, downloadFileName: '/xdiarys_' + paramTN + '.exe' });
            }

            var local = _Locale2["default"].GetInstance();
            document.title = local.getMessagebyId('www_title');

            var lang = local.getLang();
            if (lang === 'chs') {

                this.GetContantUs();
                this.setState({ showBeianText: true, showHelp: true, downloadHost: 'https://download.xdiarys.com' });
            }

            var country = 'us';
            if (lang == 'chs') {
                country = 'cn';
            } else if (lang == 'cht') {
                country = 'tw';
            } else if (lang == 'kor') {
                country = 'kr';
            }

            var macOSUrl = 'https://apps.apple.com/' + country + '/app/CalendarTask/id1570563588';
            var iOSUrl = 'https://apps.apple.com/' + country + '/app/CalendarTask/id1570563588?platform=iphone';
            this.setState({ macOSUrl: macOSUrl, iOSUrl: iOSUrl });

            // 获取参数

            var paramRcmd = search.get("rcmd");
            var login = search.get("login");

            this.setState({ paramTN: paramTN, paramRcmd: paramRcmd });

            // 获取超时时间
            var paramExpTime = search.get("exptime");
            if (paramExpTime && paramExpTime.length > 0) {
                var timestamp = Date.parse(paramExpTime);
                var curTimestamp = Date.parse(new Date());
                var diffDay = (timestamp - curTimestamp) / (1000 * 60 * 60 * 24);
                diffDay = Math.floor(diffDay);

                if (diffDay > 0 && diffDay <= 30) {
                    this.setState({ expTime: paramExpTime, showExpTime: true });
                }
            }

            if (login == '1') {

                this.listenPay();

                var url = '';
                if (_Locale2["default"].GetInstance().getLocal() == 'zh') {
                    url = '/api/pay/list/wechat/web';
                    this.setState({ paymentMethod: 'wechat' });
                } else {
                    url = '/api/pay/list/paypal/web';
                    this.setState({ paymentMethod: 'paypal', threeMonthPayAmount: 4, oneYearPayAmount: 10, threeYearPayAmount: 21 });
                }

                // tab名称
                var titleText = _Locale2["default"].GetInstance().getMessagebyId('pay_title');
                document.title = titleText;

                fetch(url, {
                    method: "GET",
                    credentials: 'include',
                    headers: {
                        'Accept': 'application/json, text/plain, */*'
                    }
                }).then(function (res) {
                    return res.json();
                }).then(function (res) {
                    _this3.procPayInfo(res);
                });
            }
        }
    }, {
        key: 'componentDidMount',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var search, login, response, retObj, vData;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                search = new URLSearchParams(location.search);
                                login = search.get("login");

                                if (!(login == '1')) {
                                    _context.next = 16;
                                    break;
                                }

                                _context.prev = 3;
                                _context.next = 6;
                                return fetch('/api/users/account/info', {
                                    method: 'GET',
                                    credentials: 'include',
                                    headers: {
                                        'Accept': 'application/json, text/plain, */*'
                                    }
                                });

                            case 6:
                                response = _context.sent;
                                _context.next = 9;
                                return response.json();

                            case 9:
                                retObj = _context.sent;


                                if (retObj.result === 1) {
                                    vData = retObj.vdata;

                                    this.setState({ isVip: vData.vip || false });
                                }
                                _context.next = 16;
                                break;

                            case 13:
                                _context.prev = 13;
                                _context.t0 = _context['catch'](3);

                                console.error('Error fetching account info:', _context.t0);

                            case 16:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[3, 13]]);
            }));

            function componentDidMount() {
                return _ref2.apply(this, arguments);
            }

            return componentDidMount;
        }()
    }, {
        key: 'GetContantUs',
        value: function GetContantUs() {
            var _this = this;

            fetch('/api/help/contantus', {
                method: "GET",
                credentials: 'include',
                headers: {
                    'Accept': 'application/json, text/plain, */*'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (myJson) {

                _this.setState({ contantUsQQWindows: myJson.vdata.qqwindow });
                _this.setState({ contantUsQQMacos: myJson.vdata.qqmacos });
                _this.setState({ contantUsEmail: myJson.vdata.email });

                return myJson;
            })["catch"](function (e) {
                console.log(e);
            });
        }
    }, {
        key: 'breakLine',
        value: function breakLine(text) {
            var br = _react2["default"].createElement('br');
            var regex = /(<br \/>)/g;
            return text.split(regex).map(function (line, index) {
                alert(text);
                return line.match(regex) ? _react2["default"].createElement('br', { key: "key_" + index }) : line;
            });
        }
    }, {
        key: 'getWebSocketUrl',
        value: function getWebSocketUrl() {
            var nIndex = this.getPayIndex();
            var ishttps = 'https:' == document.location.protocol ? true : false;

            var webSocketProtocol = ishttps ? 'wss' : 'ws';
            /*let webSocketPort = ishttps ? '8083' : '8082';
            var url = `${webSocketProtocol}://notification.xdiarys.com:${webSocketPort}/ws?pcname=web`
            if( nIndex > 0 ) {
                url = `${webSocketProtocol}://notification${nIndex}.xdiarys.com:${webSocketPort}/ws?pcname=web`
            }*/
            var url = webSocketProtocol + '://notification.xdiarys.com/ws?pcname=web';
            if (nIndex > 0) {
                url = webSocketProtocol + '://notification' + nIndex + '.xdiarys.com/ws?pcname=web';
            }
            return url;
        }
    }, {
        key: 'getAccountUrl',
        value: function getAccountUrl() {
            var nIndex = this.getPayIndex();
            var url = 'https://account.xdiarys.com';
            if (nIndex > 0) {
                url = 'https://account' + nIndex + '.xdiarys.com';
            }
            return url;
        }
    }, {
        key: 'setCookie',
        value: function setCookie(name, value, seconds) {
            seconds = seconds || 0; //seconds有值就直接赋值，没有为0，这个根php不一样。
            var expires = "";
            if (seconds != 0) {
                //设置cookie生存时间
                var date = new Date();
                date.setTime(date.getTime() + seconds * 1000);
                expires = "; expires=" + date.toGMTString();
            }
            document.cookie = name + "=" + escape(value) + expires + "; path=/"; //转码并赋值
        }
    }, {
        key: 'getCookieValue',
        value: function getCookieValue(c_name) {
            if (document.cookie.length > 0) {
                //判断cookie是否存在
                //获取cookie名称加=的索引值
                var c_start = document.cookie.indexOf(c_name + "=");
                if (c_start !== -1) {
                    //说明这个cookie存在
                    //获取cookie名称对应值的开始索引值
                    c_start = c_start + c_name.length + 1;
                    //从c_start位置开始找第一个分号的索引值，也就是cookie名称对应值的结束索引值
                    var c_end = document.cookie.indexOf(";", c_start);
                    //如果找不到，说明是cookie名称对应值的结束索引值就是cookie的长度
                    if (c_end === -1) c_end = document.cookie.length;
                    //unescape() 函数可对通过 escape() 编码的字符串进行解码
                    //获取cookie名称对应的值，并返回
                    return document.cookie.substring(c_start, c_end);
                }
            }
            return ""; //不存在返回空字符串
        }
    }, {
        key: 'clearAllCookie',
        value: function clearAllCookie() {
            var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
            if (keys) {
                for (var i = keys.length; i--;) {
                    document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString();
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {

            var local = _Locale2["default"].GetInstance();

            var titleText = local.getMessagebyId('www_title');

            var img_wallpaper = require('./images/wallpaper.png');
            var intro_title = local.getMessagebyId('wapper_title');
            var intro_html = local.getMessagebyId('wapper_desc_html');

            var search = new URLSearchParams(location.search);
            var paramSrc = search.get("src");
            var paramLogin = search.get("login");

            return _react2["default"].createElement(
                'div',
                { className: 'web' },
                _react2["default"].createElement(
                    'div',
                    { className: 'baseheader' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'content' },
                        _react2["default"].createElement('img', { className: 'logo', src: _logo522x2["default"] }),
                        _react2["default"].createElement(
                            'div',
                            { className: 'left' },
                            titleText
                        ),
                        _react2["default"].createElement('div', { className: 'blank' })
                    )
                ),
                _react2["default"].createElement(
                    'div',
                    { className: 'main' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'center' },
                        _react2["default"].createElement(
                            'div',
                            { key: '1' },
                            _react2["default"].createElement(
                                'div',
                                null,
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'blockbkgnd5', id: '11' },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'block' },
                                        _react2["default"].createElement(
                                            'div',
                                            { className: 'textblock' },
                                            _react2["default"].createElement('div', { className: 'blockbkg' }),
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'title' },
                                                intro_title
                                            ),
                                            _react2["default"].createElement('div', { className: 'subtitle' }),
                                            _react2["default"].createElement('div', { className: 'content wapper-intro',
                                                dangerouslySetInnerHTML: {
                                                    __html: intro_html
                                                }
                                            })
                                        ),
                                        _react2["default"].createElement('img', { loading: 'lazy', className: 'image', src: img_wallpaper })
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return WebBaseIntro;
}(_react2["default"].Component);

exports["default"] = WebBaseIntro;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./WallpaperSkin.js
// module id = 629
// module chunks = 0